import * as z from "zod";

const StartCommerceCloudOrderBacksyncInputSchema_ = z.object({
  teamId: z.string(),
  date: z.string(),
});

export const StartCommerceCloudOrderBacksyncInputSchema: z.ZodType<StartCommerceCloudOrderBacksyncInput> =
  StartCommerceCloudOrderBacksyncInputSchema_;
export interface StartCommerceCloudOrderBacksyncInput extends z.infer<
  typeof StartCommerceCloudOrderBacksyncInputSchema_
> {}

export const startCommerceCloudOrderBacksync = {
  name: "startCommerceCloudOrderBacksync" as const,
  input: StartCommerceCloudOrderBacksyncInputSchema,
  output: z.object({ workflowId: z.string() }),
};
